/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { userSessionsList } from "../funcs/userSessionsList.js";
import { userSessionsListFacets } from "../funcs/userSessionsListFacets.js";
import { userSessionsMint } from "../funcs/userSessionsMint.js";
import { userSessionsRevoke } from "../funcs/userSessionsRevoke.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListUserSessionFacetsResult } from "../models/components/listusersessionfacetsresult.js";
import { MintUserSessionResponseBody } from "../models/components/mintusersessionresponsebody.js";
import {
  ListUserSessionFacetsRequest,
  ListUserSessionFacetsSecurity,
} from "../models/operations/listusersessionfacets.js";
import {
  ListUserSessionsRequest,
  ListUserSessionsResponse,
  ListUserSessionsSecurity,
} from "../models/operations/listusersessions.js";
import {
  MintUserSessionRequest,
  MintUserSessionSecurity,
} from "../models/operations/mintusersession.js";
import {
  RevokeUserSessionRequest,
  RevokeUserSessionSecurity,
} from "../models/operations/revokeusersession.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class UserSessions extends ClientSDK {
  /**
   * listUserSessions userSessions
   *
   * @remarks
   * List issued user_sessions in the caller's project. refresh_token_hash is never returned.
   */
  async list(
    request?: ListUserSessionsRequest | undefined,
    security?: ListUserSessionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListUserSessionsResponse, { cursor: string }>> {
    return unwrapResultIterator(userSessionsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listFacets userSessions
   *
   * @remarks
   * List available user session facet values (clients, users, servers) in the caller's project.
   */
  async listFacets(
    request?: ListUserSessionFacetsRequest | undefined,
    security?: ListUserSessionFacetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListUserSessionFacetsResult> {
    return unwrapAsync(userSessionsListFacets(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * mintUserSession userSessions
   *
   * @remarks
   * Mint a user_session on behalf of the authenticated dashboard user, bound to an issuer-gated audience: an MCP server, a meta MCP server, or a legacy toolset without an mcp_servers wrapper. Exactly one of toolset_id, mcp_server_id, or meta_mcp_server_id must be provided. The minted JWT matches the shape /token would emit after a successful OAuth dance, so the runtime MCP gateway validates it through the same path as a real MCP client's bearer.
   */
  async mint(
    request: MintUserSessionRequest,
    security?: MintUserSessionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<MintUserSessionResponseBody> {
    return unwrapAsync(userSessionsMint(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revokeUserSession userSessions
   *
   * @remarks
   * Push the session's jti into the revocation cache and soft-delete the row.
   */
  async revoke(
    request: RevokeUserSessionRequest,
    security?: RevokeUserSessionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(userSessionsRevoke(
      this,
      request,
      security,
      options,
    ));
  }
}
